import React from 'react'
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCertificate } from '@fortawesome/free-solid-svg-icons';
import { faHandshake } from '@fortawesome/free-solid-svg-icons';
import { faComment,faBullseye,faAngleRight,faMagnifyingGlass} from '@fortawesome/free-solid-svg-icons';
import '../Css/MainService.css';
import { useNavigate } from 'react-router-dom';
// 1. Import Helmet from react-helmet-async
import { Helmet } from 'react-helmet-async';

function MainService() {
    const navigate = useNavigate();

    const onClickHandler=(item)=> {
        if (item == 0) {
            navigate("/Course");
        }
        if (item == 1) {
            navigate("/JoinUs");
        }
        if (item == 2) {
            navigate("/FindHelper");
        }
        
    }

  return (
    <div>
        <Helmet>
            <title>維修王 | 香港專業家居維修平台：水電、冷氣、油漆一按配對</title>
            <meta name="description" content="維修王為香港家庭提供專業水電維修、冷氣安裝清洗、油漆及裝修服務。透過維修王 App 快速配對持牌師傅，並提供全港首創家居維修認證課程，專業解決家居奇難雜症。" /> 
            <meta property="og:title" content="維修王 - 香港最值得信賴的家居維修配對平台" />
            <meta property="og:description" content="水電、冷氣、裝修師傅即時配對！立即下載維修王 App，享受專業、透明、快速的維修服務。" />
            <meta property="og:image" content="https://homerepairexperthk.com" />
            <meta property="og:url" content="https://homerepairexperthk.com" />
        
        </Helmet>
        
       <div className="MainServiceWrapper">
        <div className="MainServiceContainer">
            <div className="MainServiceHeader">
                <FontAwesomeIcon icon={faBullseye} />&nbsp;服務
            </div>
            <div className="Underline mx-auto"></div>  
            
            <div className="MainServiceCard">
                    <div className="MainServiceCardBody">
                        <div className="CardHeader">
                            <FontAwesomeIcon icon={faCertificate} />&nbsp;維修王證書課程
                        </div>      
                        <div className="CardBodyContent">
                            <ul>
                                <li>
                                    掌握專業技能，投身熱門行業！【維修王】專業培訓課程現正招生...
                                </li>
                                <li>
                                    專為有志之士與業內人員設計的實用課程..
                                </li>  
                                <li>      
                                    十年經驗匠心傳承，品質保證...
                                </li>
                                <li>
                                    課程內容紮實，聚焦實戰應用...   
                                </li> 
                            </ul>
                        </div>  
                        <div className="CardButtonContent">
                            <button className="CardButton" onClick={()=>onClickHandler(0) }>了解更多&nbsp;<FontAwesomeIcon icon={faAngleRight} /></button>
                        </div>  
                    </div>        
                    <div className="MainServiceCardBody">
                        <div className="CardHeader">
                            <FontAwesomeIcon icon={faHandshake}/>&nbsp;四大核心優勢助你事業發展..
                        </div>
                        <div className="CardBodyContent">
                           <ul>
                                <li>海量訂單，源源不絕...</li>      
                                <li>提升收入，省心省力...</li>   
                                <li>專業形象，贏得信任..</li>  
                                <li>强大支持，如虎添翼..</li>
                            </ul>
                            <div className="CardButtonContent">
                                <button className="CardButton" onClick={()=>onClickHandler(1) }>了解更多&nbsp;<FontAwesomeIcon icon={faAngleRight} /></button>                          
                            </div>
                        </div>  
                    </div>        
                    <div className="MainServiceCardBody">
                        <div className="CardHeader">
                            <FontAwesomeIcon icon={faComment} />&nbsp;家居維修服務
                        </div>    
                        <div className="CardBodyContent">
                            <ul>
                                <li>快速回應,及時解困...</li>      
                                <li>師傅技術精湛，經驗豐富..</li>     
                                <li>透明報價，誠信為本...</li>  
                                <li>免費使用維修王平台...</li>  
                            </ul>
                            <div className="CardButtonContent">
                              <button className="CardButton" onClick={()=>onClickHandler(2) }>了解更多&nbsp;<FontAwesomeIcon icon={faAngleRight} /></button>
                            </div>
                        </div>        
                    </div>        
            </div>
            </div>
        </div>
    </div> 
       
  )
}

export default MainService
   

